import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterIndicators } from './AdvancedFilterIndicators';
import styles from './advanced-filter-view.module.sass';

export function AdvancedFilterView() {
  const filterProfileApplied = useSelector(
    (state) => state?.filter?.appliedProfile,
  );
  const tagApplied = useSelector((state) => state?.ioc?.tag);
  const feedApplied = useSelector((state) => state?.ioc?.filters?.feed);
  const allFeeds = useSelector(
    (state) => state?.ioc?.filterSettings?.feedsources,
  );
  const [activeFeed, setActiveFeed] = useState([]);

  useEffect(() => {
    if (allFeeds && feedApplied) {
      setActiveFeed(
        allFeeds?.filter((feed) => feed?.uuid === feedApplied?.[0])?.[0],
      );
    } else {
      setActiveFeed([]);
    }
  }, [allFeeds, feedApplied]);

  return (
    <div className={styles.advancedFilterView}>
      {!!(filterProfileApplied || tagApplied || feedApplied) && (
        <AdvancedFilterIndicators
          filterProfile={filterProfileApplied}
          activeTag={tagApplied}
          activeFeed={activeFeed}
        />
      )}
    </div>
  );
}
